import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { Segmented, TargetsPanel } from '../components/transactions/FinancePanels';

export default function Targets() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [department, setDepartment] = useState('sales');

  return (
    <div className={`min-h-screen p-6 ${isDark ? 'bg-[#060912]' : 'bg-gray-50'}`}>
      <div className="mb-6 flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
        <h1 className={`text-2xl font-bold tracking-tight ${isDark ? 'text-white' : 'text-gray-900'}`}>Targets</h1>
        <Segmented
          value={department}
          onChange={setDepartment}
          isDark={isDark}
          items={[
            { key: 'sales', label: 'Sales' },
            { key: 'retention', label: 'Retention' },
          ]}
        />
      </div>

      <TargetsPanel department={department} isDark={isDark} />
    </div>
  );
}
